export default "__VITE_ASSET__YlbnDq3V__"